module.exports = __webpack_public_path__ + "img/canada-infectious-diseases-female.6ee3c1e2.png";